<template>
  <div class="content">
    <ed-title-nav ref='header' :title="$t('Supplier Insurance Details')" :subtitle="subtitle">

      <!-- Action Buttons -->
      <Toolbar slot="toolbar">
        <ed-button button-class="btn btn-actionbar-primary pull-right" :disabled='!canVerify' @click="save()" name='save'>Verify</ed-button>
      </Toolbar>
    </ed-title-nav>

    <div class="container-fluid">

      <div class="content no-flex- active">
        <ed-section
          title=""
          class="no-flex active"
          wide-
        >
          <span slot="description">
          </span>
          <ed-form
            class="col-md-12 no-pad"
            :submit-visible='false'
          >
            <div class="col-md-12 no-pad">

              <div v-if='supplier.DoesNotUseAuto !== null' v-loading.2="api.$.network.insuranceSupplierDetails">
                <label>Insurance Information</label>
                <ed-notice v-for='(detail, i) in insuranceDetails' :key='i' v-bind='status(detail)' v-if='supplier.Name'>
                  <div v-html='detail.label.replace(...certified(detail.status))'>
                  </div>
                </ed-notice>
              </div>

              <ed-select
                class='col-md-4'
                name='insurance-status-cmb'
                field-label='Insurance Status'
                placeholder='Select Insurance Status'
                :options='insuranceStatuses'
                v-model=supplier.InsuranceStatus
                required
                :helptip-body='"Please select a Insurance Status."'
                helptipHeader=''
              />
              <div class="clear"></div>

              <ed-datepicker
                class='col-md-4 no-pad'
                v-if='showExpiration'
                name='expiration-date'
                field-label='Expiration Date' placeholder='Select date'
                required
                v-model=supplier.ExpirationDate
                :error='hasError'
                :helptip-body='error'
                helptipHeader=''
              />
            </div>
          </ed-form>
          <div class="clear"></div>

          <grid
            :model=SupplierCertificateModel
            :endpoint='api.$.network.insuranceCertificates'
            :filter='{ Id: { filter: $route.query.Id } }'
            :sort='{ CreatedDate: "desc" }'
            :search="true"
            :resizing="false"
            :views="false"
            :checkboxes="false"
            layout="frame"
            fit-columns
            footer
            alias='InsuranceCertificatesGrid'
            ref='InsuranceCertificatesGrid'
            export-uri='InsuranceSupplierCertificates/ExportList'
          />

        </ed-section>
      </div>

    </div>
  </div>
</template>

<script>

import Grid from '@/components/Grid'
import Toolbar from '@/components/_modules/I2P/components/TheToolbar'

import SupplierCertificateModel from './models/supplier-certificate-model'

const STATUS = {
  SUFFICIENT: 'Sufficient',
  INSUFFICIENT: 'Insufficient',
  N_A: 'N/A'
}

const DETAILS = {
  NO_AUTO: 'Automobile Insurance - The supplier certified that they do not require or involve the ownership, maintenance, or use of an auto.',
  NO_WORKER_COMPENSATION: 'Workers Compensation Insurance - The supplier certified that they do not have any additional employees and therefore are not required to carry Workers Compensation insurance.'
}

const certified = status => status
  ? [`certified`, `<b>certified</b>`]
  : [`certified`, `<b>has not certified</b>`]

export default {
  components: {
    Grid,
    Toolbar
  },

  computed: {
    subtitle() {
      return this.supplier.Name
        ? `${this.supplier.Name}  (${this.supplier.EoNumber})`
        : '...'
    },
    showExpiration() {
      return this.supplier.InsuranceStatus === STATUS.SUFFICIENT
    },
    canVerify() {
      return ~this.insuranceStatuses.indexOf(this.supplier.InsuranceStatus)
    },
    hasError() {
      return !!this.error
    },
    insuranceDetails() {
      return this.insuranceDetailsOptions // .filter(o => o.status)
    }
  },

  data () {
    return {
      certified,
      SupplierCertificateModel,
      supplier: {Name: '', EoNumber: ''},
      insuranceDetailsOptions: [
        {
          label: DETAILS.NO_AUTO,
          status: null
        }, {
          label: DETAILS.NO_WORKER_COMPENSATION,
          status: null
        }
      ],
      insuranceStatuses: [STATUS.SUFFICIENT, STATUS.INSUFFICIENT, STATUS.N_A],

      status: detail => ({
        type: detail.status === null ? 'info' : detail.status ? 'alt' : 'info'
        // icon: detail.status === null ? 'fas fa-circle' : detail.status ? 'fas fa-check' : 'fas fa-times-circle'
      }),

      error: ''
    }
  },

  created() {
    this.api.get(this.api.$.network.insuranceSupplierDetails + '/' + this.$route.query.Id)
    .then(r => {
      if (r.data) {
        this.supplier = r.data
        this.insuranceDetailsOptions[0].status = r.data.DoesNotUseAuto
        this.insuranceDetailsOptions[1].status = r.data.HasNoEmployees
      }
    })
  },

  mounted() {
    this.notifyFullscreen(true)
  },
  beforeDestroy() {
    this.notifyFullscreen(false)
  },

  methods: {
    save() {
      if (!this.showExpiration) {
        this.supplier.ExpirationDate = null
      } else if (!this.supplier.ExpirationDate) {
        this.error = 'The Expiration Date is required.'
        return
      }
      this.error = ''

      this.api.post(this.api.$.network.insuranceSupplierDetails + '/' + this.$route.query.Id, {
        data: this.supplier
      }).then(r => {
        if (r.data) {
          this.$router.go(-1)
          this.$nextTick(() => {
            this.$notifications.notify({
              message: `Verification for ${this.supplier.Name} has been successfully recorded.`,
              type: 'info',
              placement: { from: 'top', align: 'center' }
            })
          })
        }
      })
    },
    notifyFullscreen(on) {
      try {
        window.parent.postMessage(
          { type: 'legacy-fullscreen', on: !!on, source: 'insurance-view' },
          '*'
        )
      } catch (e) {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/Network/Insurance/suppliers-details.vue